import { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-600 to-purple-700 p-8 flex-col justify-between">
        <div>
          <div className="flex items-center space-x-2">
            <img 
              src="/favicon-server.svg" 
              alt="OpenApps Logo" 
              className="w-8 h-8"
            />
            <span className="text-white text-xl font-semibold">OpenApps</span>
          </div>
        </div>
        
        <div className="space-y-6">
          <h1 className="text-white text-4xl font-bold leading-tight">
            Deploy and manage MCP servers with ease
          </h1>
          <p className="text-blue-100 text-lg">
            OpenApps provides a powerful platform for creating, deploying, and monitoring 
            Model Context Protocol servers from OpenAPI specifications.
          </p>
          
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                <span className="text-white text-sm">✓</span>
              </div>
              <span className="text-white">Automatic OpenAPI to MCP conversion</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                <span className="text-white text-sm">✓</span>
              </div>
              <span className="text-white">Multiple transport protocols</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                <span className="text-white text-sm">✓</span>
              </div>
              <span className="text-white">Team collaboration and access control</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                <span className="text-white text-sm">✓</span>
              </div>
              <span className="text-white">Real-time usage analytics</span>
            </div>
          </div>
        </div>
        
        <div className="text-blue-100 text-sm">
          © 2025 OpenApps. Built for the AI/LLM ecosystem.
        </div>
      </div>

      {/* Right side - Auth form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>
    </div>
  )
} 